import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/8gWaxCEuEjSmujfeCdSPGc/tulsa-1.jpg',
  alt: 'Whole-home water softener and filtration installed next to a tankless water heater'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nJk6vDxqnDTZdZp9TP65cG/tulsa2.jpg',
  alt: 'Black water softener tank and brine tank installed in a garage'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2fD7V1Jqvp1iDkzvVDWVru/tulsa3.jpg',
  alt: 'Tulsa Water Pros water softener and brine tank professionally installed in a garage'
}];
export function Gallery() {
  return <section id="gallery" className="bg-slate-50 py-20 sm:py-24" data-id="element-47" data-mp="q5gr35sexkp8">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-48" data-mp="l76ucqr1ic1i">
        <SectionHeading eyebrow="Recent Installs" title="Clean, professional installations across Tulsa" subtitle="Real systems installed in real Tulsa homes by our certified technicians." data-id="element-49" data-mp="21mqbbujd8grl" />
        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-3" data-id="element-50" data-mp="3b647d6mw27e3">
          {IMAGES.map((img, i) => <motion.div key={img.src} initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="group aspect-[4/5] overflow-hidden rounded-2xl border border-slate-200 bg-navy-900 sm:aspect-[3/4]" data-id="element-51" data-mp="3f7g0hm4z1ar1" data-mpi={i}>
              <img src={img.src} alt={img.alt} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-52" data-mp="2wij153upvs1y" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}